export default "__VITE_ASSET__Dlt1xgks__"